const PRIMARY_MAIN_TAC = "#FFCA26";
const PRIMARY_LIGHT_TAC = "#FFCA2670";
const PRIMARY_DARK_TAC = "#FFFAEA";
const PRIMARY_CONTRAST_TEXT_TAC = "#091841";

const PRIMARY_MAIN_BANHBAO = "#EC1F28";
const PRIMARY_LIGHT_BANHBAO = "#EC1F2870";
const PRIMARY_DARK_BANHBAO = "#ffebea";
const PRIMARY_CONTRAST_TEXT_BANHBAO = "#091841";

const PRIMARY_MAIN_BANHTUOI = "#00358F";
const PRIMARY_LIGHT_BANHTUOI = "#00358F70";
const PRIMARY_DARK_BANHTUOI = "#EAF2FF";
const PRIMARY_CONTRAST_TEXT_BANHTUOI = "#091841";

const SECONDARY_MAIN = "#378AEC";
const SECONDARY_LIGHT = "#E0EEFF";
const SECONDARY_DARK = "#378AEC70";
const SECONDARY_CONTRAST_TEXT = "#272E3A";

const ERROR_MAIN = "#EC1C24";
const ERROR_LIGHT = "#F84F06";
const ERROR_DARK = "#FFECB3";
const ERROR_CONTRAST_TEXT = "";

const INFO_MAIN = "#ffffff90";
const INFO_LIGHT = "#828282";
const INFO_DARK = "#FEF9EA"; //Change
const INFO_CONTRAST_TEXT = "#d3d3d3";

const SUCCESS_MAIN = "#18B13A";
const SUCCESS_LIGHT = "";
const SUCCESS_DARK = "";
const SUCCESS_CONTRAST_TEXT = "";

const TEXT_MAIN = "#E3B616";
const CONTRAST_TEXT_TAC = "#091841";
const CONTRAST_TEXT_BANHBAO = "#ffffff";
const CONTRAST_TEXT_BANHTUOI = "#ffffff";

const BUTTON_MAIN = "#2F3D60";

const GRAY_50 = "#5E5F77";
const GRAY_100 = "#7E8DB4";
const GRAY_200 = "#F2F2F2";
const GRAY_300 = "#403F3F";
const GRAY_400 = "#4F4F4F";
const GRAY_500 = "#9B9B9B";
const GRAY_600 = "#F4F6FA";
const GRAY_700 = "#7D7D7D";
const GRAY_800 = "#E9E8E8";
const GRAY_900 = "#BDBDBD";
const GRAY_A100 = "#00000000";
const GRAY_A200 = "#E9E8E8";
const GRAY_A400 = "#F7F7F7";
const GRAY_A700 = "#F3F6FB";

const themeDefault = {
	PRIMARY_MAIN_TAC,
	PRIMARY_LIGHT_TAC,
	PRIMARY_DARK_TAC,
	PRIMARY_CONTRAST_TEXT_TAC,

	PRIMARY_MAIN_BANHBAO,
	PRIMARY_LIGHT_BANHBAO,
	PRIMARY_DARK_BANHBAO,
	PRIMARY_CONTRAST_TEXT_BANHBAO,

	PRIMARY_MAIN_BANHTUOI,
	PRIMARY_LIGHT_BANHTUOI,
	PRIMARY_DARK_BANHTUOI,
	PRIMARY_CONTRAST_TEXT_BANHTUOI,

	SECONDARY_MAIN,
	SECONDARY_LIGHT,
	SECONDARY_DARK,
	SECONDARY_CONTRAST_TEXT,

	ERROR_MAIN,
	ERROR_LIGHT,
	ERROR_DARK,
	ERROR_CONTRAST_TEXT,

	INFO_MAIN,
	INFO_LIGHT,
	INFO_DARK,
	INFO_CONTRAST_TEXT,

	SUCCESS_MAIN,
	SUCCESS_LIGHT,
	SUCCESS_DARK,
	SUCCESS_CONTRAST_TEXT,

	TEXT_MAIN,
	CONTRAST_TEXT_TAC,
	CONTRAST_TEXT_BANHTUOI,
	CONTRAST_TEXT_BANHBAO,

	BUTTON_MAIN,

	GRAY_50,
	GRAY_100,
	GRAY_200,
	GRAY_300,
	GRAY_400,
	GRAY_500,
	GRAY_600,
	GRAY_700,
	GRAY_800,
	GRAY_900,
	GRAY_A100,
	GRAY_A200,
	GRAY_A400,
	GRAY_A700
};

export default themeDefault;
